    <h3>Letzte {{ DayCount }} Tage KW {{ FromWeek }} - {{ ToWeek }}</h3>
    <ng-container *ngIf="BtgbTable$ | async as table; else loading">
        <div class="btgb-table-wrapper">
            <table>
                <tr *ngFor="let row of table.rows; let first = first; let i = index">
                    <ng-container *ngIf="first">
                        <th class="theme-override" [class]="table.rows[i].theme">
                            <button mat-mini-fab aria-label="{{ table.rows[i].label }}" (click)="table.rows[i].onClick()" color="primary">
                                <fa-icon [icon]="table.rows[i].icon"></fa-icon>
                            </button>
                        </th>
                        <th *ngFor="let col of table.columns">
                            {{ col[i].text || '' }}
                            <span class="sub-line" *ngIf="col[i].subLine as subLine"><br />{{ subLine }}</span>
                        </th>
                    </ng-container>
                    <ng-container *ngIf="!first">
                        <td class="theme-override" [class]="table.rows[i].theme">
                            <button mat-mini-fab aria-label="{{ table.rows[i].label }}" (click)="table.rows[i].onClick()" color="primary">
                                <fa-icon [icon]="table.rows[i].icon"></fa-icon>
                            </button>
                        </td>
                        <td *ngFor="let col of table.columns">
                        <span (click)="col[i].onClick ? col[i].onClick() : {}" [style.cursor]="col[i].onClick ? 'pointer' : 'text'">
                            {{ col[i].text || '' }}
                            <span *ngIf="col[i].suffixText" class="suffixText">
                                <br />
                                {{ col[i].suffixText }}
                            </span>
                        </span>
                            <div
                                *ngIf="col[i].colorDot as color"
                                class="color-dot"
                                [matTooltip]="col[i].tooltip"
                                (click)="col[i].onClick ? col[i].onClick() : {}"
                                [style.cursor]="col[i].onClick ? 'pointer' : 'default'"
                                [style.background-color]="color"
                            ></div>
                            <span class="sub-line" *ngIf="col[i].subLine as subLine">{{ subLine }}</span>
                        </td>
                    </ng-container>
                </tr>
            </table>
        </div>
    </ng-container>

<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
